export type AdminSection =
  | "dashboard"
  | "alerts"
  | "users"
  | "errors"
  | "surfspots"
  | "webcams"
  | "billing"
  | "system";

const ADMIN_SECTIONS = new Set<AdminSection>([
  "dashboard",
  "alerts",
  "users",
  "errors",
  "surfspots",
  "webcams",
  "billing",
  "system",
]);

/** Resolve the selected admin destination from a wouter search string. */
export function adminSectionFromSearch(search: string): AdminSection {
  const query = search.startsWith("?") ? search.slice(1) : search;
  const view = new URLSearchParams(query).get("view");

  if (view === "home") return "dashboard";
  return view && ADMIN_SECTIONS.has(view as AdminSection)
    ? (view as AdminSection)
    : "dashboard";
}

/** Build a canonical admin destination while retaining unrelated query state. */
export function adminSectionHref(section: AdminSection, search = ""): string {
  const query = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(query);
  params.set("view", section);
  return `/admin?${params.toString()}`;
}
